import $ from 'jquery'
import _ from 'lodash'
import $store from '../store'
import dialog from './nikan-dialog-plugin'
import { markRaw } from 'vue'
import { globalLogger } from './logger'
import { nextUID } from '~/plugins/helper'

const NikanModalStorage = {
  install(Vue, options) {
    Vue.mixin({
      methods: {
        showModal(modal) {
          modal.component = markRaw(modal.component)

          if (modal.component.modal && !modal.component.modal.stateUID)
            globalLogger.warn(`component with path: ${modal.component.__file} doesn't provide modal's stateUID, It's recommended to fill StateUID for modal size cache clearance.`)

          if (!modal.component.modal)
            modal.component.modal = {
              stateUID: this.idGenerator(5),
              size: 'fullscreen',
              helpTag: ''
            }

          if (modal.component.modal.checkDataChange === undefined)
            modal.component.modal.checkDataChange = true

          modal = _.extend({ title: '', buttons: [] }, modal)

          const token = _.get(modal, 'component.modal.policyToken')

          return new Promise((resolve, reject) => {
            if (Vue.$nikan.checkPermission(token)) {
              modal.resolve = resolve
              modal.reject = reject

              $store.dispatch('addModal', modal)
            } else {
              dialog({
                title: this.$t('msg.access-denied.title'),
                body: this.$t('msg.access-denied.body'),
                type: 'error',
                autoClose: true
              })

              reject(new Error('User needs additional privileges in order to perform this action.'))
            }
          })
        },
        resolve(response, close = true) {
          if (!close)
            this.$emit('resolve', response)
          else
            this.close(response)
        },
        reject(error) {
          if (typeof error !== 'undefined' && (typeof error !== 'string' || error !== '')) {
            this.writeError(error)
          }

          this.$emit('reject', error)
          this.close()
        },
        close(response) {
          $('.modal-item-locker').last().removeClass('show')
          this.defer(() => {
            this.$emit('resolve', response)
            $store.dispatch('removeModal')
            if ($store.state.modals.length === 0) {
              var tab = $('.nk-tabs-component-panels section:visible')

              if (!tab.has(':focus')) {
                tab.focus()
                var startup = tab.find('[startup]')
                if (startup.length > 0) {
                  startup.focus()
                }
              }
            }
          }, 300)
        },

        prepareWindow(title, buttons) {
          this.$emit('title-changed', title)
          if (!buttons) buttons = []
          for (var i = 0; i < buttons.length; i++) {
            if (buttons[i].handle)
              buttons[i].handle = buttons[i].handle.bind(this)
            if (buttons[i].items) {
              for (var j = 0; j < buttons[i].items.length; j++) {
                if (buttons[i].items[j].handle) {
                  buttons[i].items[j].handle = buttons[i].items[j].handle.bind(this)
                }
                buttons[i].items[j].id = nextUID()
              }
            }
            if (typeof buttons[i] === 'object') {
              buttons[i].id = nextUID()
            }
          }
          this.addButtons(...buttons)
          // }
        },
        addButtons() {
          if (arguments.length > 0) {
            this.$emit('buttons-changed', Array.from(arguments))
          }
        }
      }
    })
  }
}

export default NikanModalStorage
